import { FC, ReactElement } from 'react';

import { EvSwitch } from '@evinced-private/ui-common';

interface IBestPracticesButton {
	onChange: (withBestPractices: boolean) => void;
	withBestPractices: boolean;
}

export const BestPracticesButton: FC<IBestPracticesButton> = ({
	onChange,
	withBestPractices
}): ReactElement => {
	return (
		<EvSwitch onChange={onChange} checked={withBestPractices} label="Include Best Practices" />
	);
};
